<template>
  <router-view
      v-if="$store.state.faculdade != null"
      :key="$route.fullPath"></router-view>
</template>

<script>
import axios from "./axios.js";

export default {
  props: ['language','baseUrl','themePath',"id"],
  data(){
    return {
     /* faculdade: null,
      name: ""*/
    }
  },
  created() {
    axios.get(`/faculdades/${this.id}?idioma=${this.language}`).
      then(data => {
        /*this.faculdade = data.data;
        this.name = data.data.name.replace(/-/g,"")*/
        this.$store.commit("setFaculdade", data.data);
        this.$store.commit("setFaculdadeID", data.data.ID);
        this.$store.commit("setFaculdadeName", data.data.name.replace(/-/g,""));
        this.$store.commit("setLanguage",this.language);
    }).
    catch(error => {
      console.log(error);
    })
  },
  provide() {
    return {
      id: this.id,
      language: this.language
    }
  }
}
</script>

<style lang="scss">

@font-face {
  font-family: "Montserrat Black";
  src: url("./assets/fonts/Montserrat-Black.otf") format("opentype");
  font-display: swap;
}

@font-face {
  font-family: "Montserrat Bold";
  src: url("./assets/fonts/Montserrat-Bold.otf") format("opentype");
  font-display: swap;
}

@font-face {
  font-family: "Montserrat Light";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-Light.otf") format("opentype");
}

@font-face {
  font-family: "Montserrat";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-Regular.otf") format("opentype");
}

@font-face {
  font-family: "Montserrat SemiBold";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-SemiBold.otf") format("opentype");
}

@font-face {
  font-family: "Montserrat Thin";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-Thin.otf") format("opentype");
}

@font-face {
  font-family: "PT Sans";
  src: url("./assets/fonts/PTSans.woff2") format('woff2');
}

@font-face {
  font-family: "PT Sans Italic";
  src: url("./assets/fonts/PTSansItalic.woff2") format('woff2');
}

@font-face {
  font-family: "PT Sans Bold Italic";
  src: url("./assets/fonts/PTSansBoldItalic.woff2") format('woff2');
}



.darkbackground.artesehumanidades{
  background-color: #9C99DA;
}

.darkbackground.cienciasexactasedaengenharia,
.darkbackground.cienciasexatasedaengenharia{
  background-color: #87CEFA;
}

.darkbackground.cienciassociais{
  background-color: #FF5A5A;
}

.darkbackground.cienciasdavida{
  background-color: #fea461;
}

.darkbackground.tecnologiasegestão,
.darkbackground.escolasuperiordetecnologiasegestao{
  background-color: #ffcc66;
}

.darkbackground.escolasuperiordesaude{
  background-color: #91E2C3;
}

.darkcolor.artesehumanidades{
  color: #9C99DA;
}

.darkcolor.cienciasexatasedaengenharia{
  color: #87CEFA;
}

.darkcolor.cienciassociais{
  color: #FF5A5A;
}

.darkcolor.cienciasdavida{
  color: #fea461;
}

.darkcolor.escolasuperiordetecnologiasegestao{
  color: #ffcc66;
}

.darkcolor.escolasuperiordesaude{
  color: #91E2C3;
}


.departamentolink.artesehumanidades,
.departamentos3.darkcolor.artesehumanidades{
  color: #8a8acd;
}

.departamentolink.cienciasexatasedaengenharia,
.departamentos3.darkcolor.cienciasexatasedaengenharia{
  color: #649fd1;
}

.departamentolink.cienciassociais,
.departamentos3.darkcolor.cienciassociais{
  color: #9b3232;
}

.departamentolink.cienciasdavida,
.departamentos3.darkcolor.cienciasdavida{
  color: #fea461;
}

.departamentolink.escolasuperiordetecnologiasegestao,
.departamentos3.darkcolor.escolasuperiordetecnologiasegestao{
  color: #ffcc66;
}

.departamentolink.escolasuperiordesaude,
.departamentos3.darkcolor.escolasuperiordesaude{
  color: #91E2C3;
}
</style>
